<template>
  <main-content-layout :title="$gettext('ATTENDANCE_RECORDS')">
    <div class="tw-p-4">
      <jt-data-table
        :api-mode="false"
        :data="dataGrid.registros"
        :fields="dataTableGrid.columns"
        :is-paginated="false"
        row-key="id"
        row-buttons
      >
        <template #header="{ props }">
          <q-tr :props="props" class="table-header">
            <q-td
              v-for="col in props.cols.filter((p) => p.render != 'HIDDEN')"
              :key="col.name"
              :props="props"
            >
              <div style="display: flex; justify-content: center">
                {{ col.label }}
              </div>
            </q-td>
            <q-td>
              {{ $gettext("MORE") }}
            </q-td>
            <q-td />

          </q-tr>
        </template>

        <template #body="{ props }">
          <q-tr class="text-left">
            <q-td
              v-for="col in props.cols.filter((p) => p.render != 'HIDDEN')"
              :key="col.name"
              :props="props"
            >
              <span
                v-if="
                  col.field == 'startDate' ||
                  (col.field == 'endDate' && col.value)
                "
                class="cell-values"
              >
                <span style="font-size: 14px">
                  {{
                    moment(col.value, "DD-MM-YYYY HH:mm:ss").format(
                      "DD/MM/YYYY"
                    )
                  }}
                </span>
                <span style="font-size: 10px">
                  {{
                    moment(col.value, "DD-MM-YYYY HH:mm:ss").format("HH:mm:ss")
                  }}
                </span>
              </span>
              <span v-else-if="col.render != 'HIDDEN'" class="cell-values">
                {{ col.value }}
              </span>
            </q-td>
            <q-td style="width: 1px">
              <q-btn
                flat
                round
                color="primary"
                class="q-mr-sm"
                :icon="
                  props.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                "
                @click="props.expand = !props.expand"
              />
            </q-td>
            <q-td style="width: 1px" v-if="datatable.buttons.length > 0" nowrap>
              <span class="buttons-row">

                <span
                  v-for="(button, index) in datatable.buttons"
                  :key="index"
                  :class="button.name"
                >
                  <q-btn
                    flat
                    small
                    :class="button.name + '-btn protocol-close'"
                    color="primary"
                    @click="actionButton(button, props.row)"
                  >
                    <q-icon :name="iconAction(button)" size="22px" />
                    <q-tooltip v-if="button.tooltip">
                      {{ tooltip(button, props.row) }}
                    </q-tooltip>
                    <q-tooltip v-else>{{ button.label }}</q-tooltip>
                  </q-btn>
                </span>
              </span>
            </q-td>

          </q-tr>
          <q-tr v-show="props.expand" :props="props">
            <q-td colspan="100%">
              <div class="row hidden-row">
                <div
                  v-for="(col, index) in props.cols.filter(col => col.name == 'startObservation' || col.name == 'endObservation')"
                  :key="index"
                  style="padding: 5px 8px"
                  :class="index % 2 != 0 ? 'col-4' : 'col-4 row-paint-colapse'"
                >
                  <strong
                    ><label>{{ col.label }}:</label></strong
                  >
                  {{
                    col.field == "valor" || col.field == "vlpag"
                      ? $toLocaleStringBr(props.row[col.field])
                      : props.row[col.field]
                  }}
                </div>
              </div>
            </q-td>
          </q-tr>
        </template>
      </jt-data-table>
      <service-request-detail-modal
        ref="detailProtocol"
        v-if="flModalShowProtocol"
        :show="flModalShowProtocol"
        :forms="forms"
        :detail="true"
        :serviceRequest="serviceRequest"
        @input="
          () => {
            this.modalDetail.show = false;
          }
        "
        :label="$gettext('DEFINITION_OF_GROUPS')"
      >
        <template slot="form">
        </template>
      </service-request-detail-modal>
    </div>
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestListController from './ServiceRequestListController'
import moment from 'moment'
import { JtDataTable } from 'jtech-webcomps'
import ServiceRequestDetailModal from './ServiceRequestDetailModal.vue'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
import ServiceRequestController from '../../../ServiceRequestController'

@Component({
  name: 'ServiceRequestList',
  components: {
    ServiceRequestDetailModal,
    JtDataTable,
    MainContentLayout
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestList extends Vue {
  controllerRequest = ServiceRequestListController.getInstance();
  controller = ServiceRequestController.getInstance();
  moment = moment;
  modalDetail = {
    show: false
  };

  serviceRequest = null;
  get serviceRequestProp () {
    return this.serviceRequest
  }

  get flModalShowProtocol () {
    return this.modalDetail.show
  }

  get dataGrid () {
    return this.data
  }

  get dataTableGrid () {
    return this.datatable
  }

  data = [];
  datatable = {};

  async mounted () {
    this.datatable = await this.controllerRequest.loadDatatable()
    await this.loadFiles()
  }

  async loadFiles () {
    const registros = await this.controllerRequest.loadDatatableModel({
      personDocument: this.controller.state.serviceRequests[this.protocol].clientID
    })
    this.data = registros
  }

  iconAction (button) {
    if (button.nmIcon) return button.nmIcon
    switch (button.name) {
      case 'icAlterar':
        return 'border_color'
      case 'icExcluir':
        return 'delete_forever'
      case 'icDetalhar':
        return 'visibility'
      default:
        return 'create'
    }
  }

  actionButton (button, params) {
    if (button.name == 'icDetalhar') {
      this.serviceRequest = params
      this.modalDetail.show = !this.modalDetail.show
    }
  }
}
export default ServiceRequestList
</script>
<style lang="stylus" scooped>
.cell-values {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.buttons-row {
  display: inline-block;
  width: max-content;
}
</style>
